import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import CorporateEventsBanner from "../../../../components/reusable-components/b2b/corporate-events-banner/CorporateEventsBanner";
import CorporateEventGrid from "../CorporateEventsGrid";
import { useAppDispatch, useAppSelector } from "../../../../hooks/storeHooks";
import { getCorporateEventsHistoryThunk } from "../../../../store/b2b/corporateEvent/corporateEventThunk";
import IsMobile from "../../../../hooks/isMobile";
import { getCorporateDeclinedEventsListColumns } from "../../../../utils/B2B/corporateEventsUtils";
import { ROUTE_QUERY_CONSTANTS } from "../../../../routes";
import { EVENT_TYPE_HISTORY } from "../../../../types/eventTypes";
import { GridIdsEnum } from "../../../../constants/enums";
import { useOnUpdateUserEvents } from "../../../../hooks/firestoreHooks/eventListUpdateHook";

const DeclinedEvents = () => {
	const dispatch = useAppDispatch();
	const isMobile = IsMobile();
	const { corporateEvents } = useAppSelector((state) => state.corporateEvent);
	const [shouldStartUpdating, setShouldStartUpdating] = useState(false);
	const columns = getCorporateDeclinedEventsListColumns();

	const fetchEventListData = () => {
		dispatch(getCorporateEventsHistoryThunk(EVENT_TYPE_HISTORY.DECLINED));
		setShouldStartUpdating(true);
	};

	useOnUpdateUserEvents(shouldStartUpdating, fetchEventListData);

	useEffect(() => {
		fetchEventListData();
	}, []);

	return (
		<Box className="content">
			<CorporateEventsBanner subtitle="Corporate Declined Events" />
			<Box
				className="pageLayout"
				sx={{
					display: "flex",
					flexDirection: isMobile ? "column-reverse" : "column",
					paddingTop: "0px !important"
				}}>
				<CorporateEventGrid
					corporateEventList={corporateEvents}
					columns={columns}
					title="Declined Events"
					queryParams={ROUTE_QUERY_CONSTANTS.CorporateDeclinedEvents}
					gridId={GridIdsEnum.CORPORATE_EVENTS_DECLINED}
					message="No declined events yet."
				/>
			</Box>
		</Box>
	);
};

export default DeclinedEvents;
